import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';

import Fluid from 'components/Fluid';
import { ReactComponent as ArrowLeft } from 'images/icons/arrow_left_long.svg';
import { ReactComponent as ArrowRight } from 'images/icons/arrow_right_long.svg';
import breakpoints from 'utils/breakpoints';

import 'swiper/css';

const MapSlider = ({ children, permalinks = [], initialSlide = 0, onSwiperReady, onVisibleSlidesChange, onSlideClick, hasEnteredView, title }) => {
	const swiperRef = React.useRef(null);
	
	const emitVisibleSlides = React.useCallback((swiper) => {
		if (!swiper || !onVisibleSlidesChange) return;

		const dynamicSlidesPerView = swiper.slidesPerViewDynamic ? swiper.slidesPerViewDynamic() : 1;
		const slidesPerView = Math.max(1, Number.isFinite(dynamicSlidesPerView) ? Math.round(dynamicSlidesPerView) : 1);
		const startIndex = Math.max(0, swiper.activeIndex || 0);
		const visibleIndices = Array.from({ length: slidesPerView }, (_, offset) => (
			Math.min(startIndex + offset, Math.max(permalinks.length - 1, 0))
		));

		onVisibleSlidesChange({
			activeIndex: startIndex,
			visiblePermalinks: visibleIndices.map((index) => permalinks[index]).filter(Boolean),
		});
	}, [onVisibleSlidesChange, permalinks]);

	return (
		<Box className={`neighborhoodsMap__sliderWrap ${hasEnteredView ? 'neighborhoodsMap__sliderWrap--enteredView' : ''}`}>
			<Fluid layout="8 4">
				{title && (
						<Box
							className="neighborhoodsMap__titleContainer"
						>
							<Typography
								variant="h3"
								component="div"
								fontWeight="bold"
								className="neighborhoodsMap__title"
							>
								{title}
							</Typography>
						</Box>
				)}
				<div className="cardSlider__navigation">
					<button disabled={swiperRef.current?.isBeginning} onClick={() => swiperRef.current?.slidePrev()} aria-label="Previous slide">
						<ArrowLeft />
					</button>
					<button disabled={swiperRef.current?.isEnd} onClick={() => swiperRef.current?.slideNext()} aria-label="Next slide">
						<ArrowRight />
					</button>
				</div>
			</Fluid>
			<Fluid layout="12" bleed="right">
				<Swiper
					initialSlide={initialSlide}
					slidesPerView={3}
					slidesPerGroup={3}
					spaceBetween={10}
					loop={false}
					className={'neighborhoodsMap__slider'}
					autoHeight={false}
					onSwiper={(swiperInstance) => {
						swiperRef.current = swiperInstance;
						if (onSwiperReady) onSwiperReady(swiperInstance);
						emitVisibleSlides(swiperInstance);
					}}
					onSlideChange={(swiperInstance) => {
						emitVisibleSlides(swiperInstance);
					}}
					onBreakpoint={(swiperInstance) => {
						emitVisibleSlides(swiperInstance);
					}}
					breakpoints={{
						0: {
							slidesPerView: 1.25,
							slidesPerGroup: 1,
						},
						[breakpoints.values.sm]: {
							slidesPerView: 2.25,
							slidesPerGroup: 2,
						},
						[breakpoints.values.md]: {
							slidesPerView: 3.25,
						},
					}}
				>
					{children?.map((child, index) => (
						<SwiperSlide
							style={{ height: 'auto', display: 'flex' }}
							className="neighborhoodsMap__slide"
							key={`map-slider-slide-${index}`}
							onClick={(e) => {
								if (!onSlideClick) return;
								onSlideClick(e, {
									index,
									permalink: permalinks[index] || null
								});
							}}
						>
							{child}
						</SwiperSlide>
					))}
				</Swiper>
			</Fluid>
		</Box>
	)
};

export default MapSlider;